import { Chip, TableCell, TableRow } from '@mui/material'
import React from 'react'
import { Employee } from '../../types/Employee/Employee'
import { useNavigate } from 'react-router-dom'

type QCRowProps = {
	agent: Employee
}

export function AgentRow({ agent }: QCRowProps) {
	const navigate = useNavigate()

	return (
		<>
			<TableRow
				onClick={() => navigate(`${agent.id}`)}
				key={agent.id}
				sx={{ cursor: 'pointer' }}
			>
				<TableCell align='left'>
					{agent.firstName} {agent.lastName}
				</TableCell>
				<TableCell align='center'>{agent.employeeId}</TableCell>
				<TableCell align='center'>{agent.primaryCraft}</TableCell>
				<TableCell align='center'>{agent.classification}</TableCell>
				<TableCell align='center'>
					<Chip label={'Online'} variant={'Online'} />
				</TableCell>
			</TableRow>
		</>
	)
}
